import { render, staticRenderFns } from "./bankDirectDetail.vue?vue&type=template&id=4049b21c&scoped=true&"
import script from "./bankDirectDetail.vue?vue&type=script&lang=js&"
export * from "./bankDirectDetail.vue?vue&type=script&lang=js&"
import style0 from "./bankDirectDetail.vue?vue&type=style&index=0&id=4049b21c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4049b21c",
  null
  
)

export default component.exports